export default "__VITE_ASSET__DYJzICKl__"